


import {
  defineComponent,
  reactive,
  PropType,
  computed,
} from '@vue/composition-api';
import useSettouPatrolContext from '@/components/Sp/Johaisetsu/SettouPatrol/composables/useSettouPatrolContext';
import StartWork from '@/components/Sp/Johaisetsu/SettouPatrol/SettouReportCommon/StartWork/index.vue';
import { Location } from '@/models/index';
import {
  JohaisetsuSettouPatrolCreateParamsCommon,
} from '@/models/apis/johaisetsu/settouPatrol/johaisetsuSettouPatrolRequestCommon';
import {
  JohaisetsuSettouOnsiteManagementCreateParams,
} from '@/models/apis/johaisetsu/settouPatrol/settouOnsiteManagement/johaisetsuSettouOnsiteManagementRequest';
import { resolveInitialWorkType } from '@/components/Sp/Johaisetsu/SettouPatrol/SettouOnsiteManagement/utils';

interface State {
  workType: string;
  roadNameDisp: string;
  workArea: string;
}

export default defineComponent({
  props: {
    displayJohaisetsuHan: {
      type: String,
      required: true,
    },
    selectedJohaisetsuType: {
      type: String,
      required: true,
    },
    currentLocation: {
      type: Object as PropType<Location>,
    },
    isRequesting: {
      type: Boolean,
      required: true,
    },
  },
  setup(props, { emit }) {
    const {
      roadNames,
      johaisetsuTypes,
      johaisetsuTypeMap,
      isShowJohaisetsuTypeSelect,
    } = useSettouPatrolContext({ selectedJohaisetsuType: props.selectedJohaisetsuType });
    const state = reactive<State>({
      workType: resolveInitialWorkType(props.selectedJohaisetsuType, johaisetsuTypes),
      roadNameDisp: '',
      workArea: '',
    });

    const isValidInput = computed(() => {
      return !!state.workType;
    });

    const startMoving = async(createReportParameters: JohaisetsuSettouPatrolCreateParamsCommon) => {
      if (!state.workType) {
        emit('showErrorOnCommon', '作業種別が必須です。');
        return;
      }

      const createSettouOnsiteManagementDetailParameters: JohaisetsuSettouOnsiteManagementCreateParams = {
        ...createReportParameters,
        road_name_disp: state.roadNameDisp,
        work_area: state.workArea,
        work_type: johaisetsuTypeMap[state.workType].work_type,
      };

      emit('startMovingOnCommon', createSettouOnsiteManagementDetailParameters, state.workType);
    };
    const showErrorMsg = (msg: string) => {
      emit('showErrorOnCommon', msg);
    };

    return {
      state,
      isValidInput,
      roadNames,
      johaisetsuTypes,
      isShowJohaisetsuTypeSelect,
      startMoving,
      showErrorMsg,
    };
  },
  components: {
    StartWork,
  },
});
